export default __webpack_public_path__ + "static/api2-b7cf90ce6306541480402fcd2f2f4f98.png";